"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Useful for marking certain components or functions as deprecated. This will show up
 * in dev logs, but not in production.
 */
function deprecate(message) {
    if (process.env.NODE_ENV !== 'production') {
        console.warn("DEPRECATED: " + message);
    }
}
exports.deprecate = deprecate;
/**
 * Adds a @deprecated('your message here') decorator that you can add
 * to class bound functions.
 */
function deprecated(message) {
    return function withDeprecationWarning(_target, propertyKey, descriptor) {
        var original = descriptor.value;
        // eslint-disable-next-line
        descriptor.value = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            deprecate(propertyKey + " - " + message);
            return original.apply(this, args);
        };
    };
}
exports.deprecated = deprecated;
//# sourceMappingURL=deprecate.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/deprecate.js
// module id = 85Av
// module chunks = 20 21 22